import { forwardRef, type HTMLAttributes } from "react"
import {
  Card as UiCard,
  CardContent as UiCardContent,
  CardFooter as UiCardFooter,
  CardHeader as UiCardHeader,
  CardTitle as UiCardTitle,
} from "@/components/ui/card"
import { cn } from "@/lib/utils"

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function Card(
  { className, ...rest },
  ref,
) {
  return (
    <UiCard
      ref={ref}
      className={cn(
        "gap-0 rounded-lg border-markv-surface-200 bg-markv-surface-50 py-0 text-markv-text-700 shadow-markv-sm",
        className,
      )}
      {...rest}
    />
  )
})

export const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardHeader({ className, ...rest }, ref) {
    return (
      <UiCardHeader
        ref={ref}
        className={cn("border-b border-markv-surface-200 px-4 py-3", className)}
        {...rest}
      />
    )
  },
)

export const CardTitle = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardTitle({ className, ...rest }, ref) {
    return (
      <UiCardTitle
        ref={ref}
        className={cn("font-display text-[14.5px] font-bold text-markv-text-700", className)}
        {...rest}
      />
    )
  },
)

export const CardBody = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardBody({ className, ...rest }, ref) {
    return (
      <UiCardContent
        ref={ref}
        className={cn("px-4 py-4 text-markv-text-700", className)}
        {...rest}
      />
    )
  },
)

export const CardFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function CardFooter({ className, ...rest }, ref) {
    return (
      <UiCardFooter
        ref={ref}
        className={cn(
          "justify-end gap-2 border-t border-markv-surface-200 px-4 py-3",
          className,
        )}
        {...rest}
      />
    )
  },
)
